const [
    _iframe
] = [
    Symbol('_iframe')
]

export default class Container {
    constructor (...props) {
        this[_iframe] = document.createElement('iframe')
    }

    /**
     * 加载URL
     * @param params
     * @returns {*|Promise<any>}
     */
    load(params) {
        let pms = new Promise((resolve,reject)=>{
            this[_iframe].onload = ()=>{
                console.log('this.wv1  load success ', this[_iframe],  params.content.fileURL)
                resolve()
            }
        })
        console.log('this.wv1  load ', this[_iframe],  params.content.fileURL)
        this[_iframe].src = params.content.fileURL
        document.documentElement.appendChild(this[_iframe])
        return pms
    }

    /**
     * 重新加载
     * @param params
     * @returns {*|Promise<any>}
     */
    reload(params) {
    }

    /**
     * 回退
     * @param params
     * @returns {*|Promise<any>}
     */
    goBack(params) {
    }

    /**
     * 重定向
     * @param params
     * @returns {*|Promise<any>}
     */
    goForward(params) {
    }

    postMessage(datas){
        this[_iframe].contentWindow.postMessage(datas)
    }

}
